<span ngForm #frm="ngForm">
<label *ngIf="label" [ngClass]="labelClass">{{ label }}<span *ngIf="required">*</span></label>
<mat-form-field [ngClass]="styleClass">
    <ng-container *ngIf="fieldType=== 'input' && dataType && dataType === 'number' && restrict" >
        <input  #control matInput id="{{ inputId }}" placeholder="{{ placeholder }}" [appCustomPatternValidator]="fieldValidationConstraints"
                [disabled]="disabled" [(ngModel)] = "result"
                appTransformInput [type]="inputType"
                 tabindex="{{ tabIndex }}"
                (ngModelChange)="onModelChanged($event)"
                (blur)="onBlur($event)"
                (change)="onChange()"
                [readonly]="readonly"
                appRestrict [restrict]="restrict" maxlength="{{ maxlength }}" (keyup.enter)="onEnter()"
                name="{{name}}"
                [attr.autocomplete]="autocomplete"
        (paste)="onPaste($event)"/>
   </ng-container>
    <ng-container *ngIf="fieldType=== 'input' && dataType && dataType === 'number' && !restrict" >
        <input  #control matInput id="{{ inputId }}" placeholder="{{ placeholder }}" [disabled]="disabled" [(ngModel)] = "result"
                appTransformInput [type]="inputType"
                 tabindex="{{ tabIndex }}"
                [readonly]="readonly"
                (ngModelChange)="onModelChanged($event)"
                (change)="onChange()"
                (blur)="onBlur($event)"
                maxlength="{{ maxlength }}" (keyup.enter)="onEnter()" (paste)="onPaste($event)"
                name="{{name}}" [appCustomPatternValidator]="fieldValidationConstraints" [attr.autocomplete]="autocomplete"/>
    </ng-container>
    <ng-container *ngIf="fieldType=== 'input' && (!dataType  ||  dataType !== 'number') && restrict" >
        <input  #control matInput id="{{ inputId }}" placeholder="{{ placeholder }}" [disabled]="disabled" [(ngModel)] = "result"
                [type]="inputType"
                tabindex="{{ tabIndex }}"
                (ngModelChange)="onModelChanged($event)"
                (blur)="onBlur($event)"
                [readonly]="readonly"
                appRestrict [restrict]="restrict" maxlength="{{ maxlength }}" (keyup.enter)="onEnter()"
                (paste)="onPaste($event)"
                (change)="onChange()"
                name="{{name}}" [appCustomPatternValidator]="fieldValidationConstraints" [attr.autocomplete]="autocomplete"/>
    </ng-container>
    <ng-container *ngIf="fieldType === 'input' && (!dataType  ||  dataType !== 'number') && !restrict" >
        <input  #control matInput id="{{ inputId }}" placeholder="{{ placeholder }}" [disabled]="disabled" [(ngModel)] = "result"
                [type]="inputType"
                tabindex="{{ tabIndex }}"
                (ngModelChange)="onModelChanged($event)"
                (blur)="onBlur($event)"
                 maxlength="{{ maxlength }}" (keyup.enter)="onEnter()"
                (keydown.enter)="onEnterKeyDown()"
                [readonly]="readonly"
                (change)="onChange()"
                (paste)="onPaste($event)" name="{{name}}" [appCustomPatternValidator]="fieldValidationConstraints" [attr.autocomplete]="autocomplete"/>
    </ng-container>
    <ng-container *ngIf="fieldType === 'textarea'">
        <textarea  #control matInput id="{{ inputId }}" placeholder="{{ placeholder }}" [disabled]="disabled" [(ngModel)] = "result" [type]="inputType"
                tabindex="{{ tabIndex }}"
                (ngModelChange)="onModelChanged($event)"
                   (change)="onChange()"
                   [readonly]="readonly"
                   maxlength="{{ maxlength }}"  cdkTextareaAutosize
                   cdkAutosizeMinRows="1"
                   [cdkAutosizeMaxRows]="rows" [name]="name" [appCustomPatternValidator]="fieldValidationConstraints"></textarea>
    </ng-container>
    <mat-error *ngIf="(this.error ||  frm.controls[name]?.errors?.regexp) && frm.controls[name]?.invalid && (frm.controls[name]?.touched || frm.controls[name]?.dirty) ">
        <ng-container *ngIf="frm.controls[name]?.errors?.regexp">
            {{ frm.controls[name].errors.regexp }}
        </ng-container>
        <ng-container *ngIf="!frm.controls[name]?.errors?.regexp">
            {{ error }}
        </ng-container>
    </mat-error>
</mat-form-field>
<span *ngIf="unit">{{ unit }}</span>
</span>
